import {
  push,
  RouterState
}                            from 'connected-react-router';
import React, {
  useEffect,
  useRef,
  useState
}                            from 'react';
import {
  useDispatch,
  useSelector
}                            from "react-redux";
//@ts-ignore
import redalertmp3           from "../../../assets/audio/redalert.mp3";
//@ts-ignore
import redalertwav           from "../../../assets/audio/redalert.wav";
import logo                  from '../../../assets/images/logo-long-Q.png';
import useClickOutside       from "../../../hooks/useClickOutside";
import usePrevious           from "../../../hooks/usePrevious";
import { ApplicationState }  from "../../../store";
import { setSelectedEvent }  from '../../../store/alerts/actions';
import {
  AlertState,
  EventType
}                            from "../../../store/alerts/types";
import { cancelAllRequests } from "../../../store/API/actions";
import { resetBrowsePanes }  from '../../../store/browse/actions';
import { SettingsState }     from '../../../store/settings/types';
import { setTimelineDate }   from '../../../store/timeline/actions';
import { Routes }            from "../../../types";
import { IconComponent }     from "../../reusable/simpleComponents";

interface Props {
  handler: () => void,
  className: string
}

const removeIsBlinking = (callback: any) => {
  setTimeout(() => {
    callback();
  }, 2700);
}

const AlertsUIComponent: React.FC<Props> = ({handler, className}) => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLAudioElement>(null);
  const btnRef = useRef<HTMLDivElement>(null);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {events, playSound, initialLoad} = useSelector<ApplicationState, AlertState>(state => state.alerts);
  const {alarmPriority, notificationPriority} = useSelector<ApplicationState, SettingsState>(state => state.settings);
  const isActive = className.indexOf('active') > -1;
  const [isNewEvents, setIsNewEvents] = useState(false);
  const [blinking, setBlinking] = useState(false);
  const isAlert = location.pathname === Routes.alerts;

  const prevStateEvents: any = usePrevious(events);

  // TODO SGS
  // Add logic for searching handled alarms and remove unused alarms from list

  // TODO check and rewrite logic for alarm and notification priority

  // useEffect(() => {
  //     if (ref.current && playSound !== null) {
  //         checkEvents();
  //     }
  // }, [playSound]);

  useClickOutside(btnRef, () => {
    if (isAlert) {
      setIsNewEvents(false);
      setBlinking(false);
    }
  }, isAlert);

  useEffect(() => {
    if (events.length > 0) {
      setIsNewEvents(true);
      setBlinking(true);
      removeIsBlinking(() => {
        setBlinking(false);
      });
      checkEvents();
    }
  }, [events]);

  const checkEvents = () => {
    const newEvent = events.filter((event) => {
      if (prevStateEvents) {
        for (let i = 0; i !== prevStateEvents.length; i++) {
          if (prevStateEvents[i].id === event.id) {
            return false;
          }
        }
      }
      return true;
    });
    if (newEvent.length > 0 && !initialLoad) {
      (+newEvent[0].prio >= +notificationPriority) && notifyMe(newEvent[0]);
      ((+newEvent[0].prio >= +alarmPriority) && ref.current) && ref.current.play();
    }
    if (playSound) {
      setIsNewEvents(!isActive);
      setBlinking(!isActive);
    }
  }

  const notifyMe = (event: EventType) => {
    const {where, what, prio} = event;
    let notification: any;
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
      notification = new Notification(`New Alert!`, {
        icon: logo,
        body: `New priority ${prio} alert on ${where} - ${what}!`
      });
      notification.onclick = function () {
        dispatch(push('alerts'));
        window.focus();

        dispatch(cancelAllRequests());
        dispatch({type: 'cancelDeviceStatus'});
        dispatch(resetBrowsePanes());
        dispatch(setSelectedEvent(event));
        event && dispatch(setTimelineDate(new Date(parseInt(event.when)).valueOf()));
      };
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(function (permission) {
        if (permission === "granted") {
          notification = new Notification(`New Alert!`, {
            icon: logo,
            body: `New priority ${prio} alert on ${where} - ${what}!`
          });
          notification.onclick = function () {
            dispatch(push('alerts'));
            window.focus();

            dispatch(cancelAllRequests());
            dispatch({type: 'cancelDeviceStatus'});
            dispatch(resetBrowsePanes());
            dispatch(setSelectedEvent(event));
            event && dispatch(setTimelineDate(new Date(event.when).valueOf()));
          };
        }
      });
    }
  }

  return (
    <div className='pos-rel' ref={btnRef}>
      {
        isNewEvents && <div className={`blink-alert-icon ${blinking ? 'active' : ''}`}/>
      }
      <IconComponent
        classValue={className}
      />
      <div className={`alerts-icon-value icon ${events.length > 99 ? 'more-alerts' : ''} ${isActive ? 'active' : ''}`}
           style={isNewEvents ? {color: "yellow"} : {}}
           title="Enter Alert Viewing Mode"
           onClick={() => {
             handler();
             if (isNewEvents) setIsNewEvents(false);
             dispatch(cancelAllRequests());
           }}
      >
        {events.length > 99 ? '99+' : events.length}
      </div>

      <audio id="redalert" preload="auto" ref={ref}>
        <source src={redalertmp3} type="audio/mpeg"/>
        <source src={redalertwav} type="audio/wav"/>
      </audio>
    </div>
  );
};

export default AlertsUIComponent